import React from 'react';
import classNames from 'classnames';
import styles from './SVGIcon.scss';

const { PI, cos, sin, min, max } = Math;

const radius = 7;
const outerRadius = 8;
const moveTo = (x, y) => `M ${x} ${y}`;
const arcTo = (largeArc, sweep, x, y) =>
  `A ${radius} ${radius} 0 ${largeArc ? 1 : 0} ${sweep ? 1 : 0} ${x} ${y}`;
const lineTo = (x, y) => `L ${x} ${y}`;
const close = () => 'Z';

const circlePos = (fraction) => [
  outerRadius + radius * sin(PI * 2 * fraction),
  outerRadius + radius * -cos(PI * 2 * fraction),
];

const InlineIconPending = () => (
  <svg viewBox="0 0 16 16" fill="none">
    <circle
      cx="8"
      cy="8"
      r="7.5"
      fill="#fff"
      stroke="var(--color-icon-lineart)"
    />
  </svg>
);

const InlineIconInProgress = ({ progressFraction }) => {
  progressFraction = min(max(progressFraction || 0, 0), 1);

  return (
    <svg viewBox="0 0 16 16" fill="none">
      <circle
        cx="8"
        cy="8"
        r="7"
        fill="#fff"
        stroke="var(--color-icon-lineart)"
        strokeWidth="2"
      />
      {!!progressFraction && (
        <path
          d={[
            moveTo(...circlePos(0)),
            arcTo(progressFraction > 0.5, true, ...circlePos(progressFraction)),
            lineTo(outerRadius, outerRadius),
            close(),
          ].join(' ')}
          fill="var(--color-icon-lineart)"
        />
      )}
    </svg>
  );
};

const InlineIconDownArrow = () => (
  <svg viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="8" fill="var(--color-icon-lineart)" />
    <path
      d="M8,12.25a.76.76,0,0,1-.75-.75v-7a.75.75,0,0,1,1.5,0v7A.76.76,0,0,1,8,12.25Z"
      fill="#fff"
    />
    <path
      d="M8,12.25A.74.74,0,0,1,7.47,12L4,8.53A.75.75,0,0,1,5,7.47l3,3,3-3A.75.75,0,0,1,12,8.53L8.53,12A.74.74,0,0,1,8,12.25Z"
      fill="#fff"
    />
  </svg>
);

const InlineIconUpArrow = () => (
  <svg viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="8" fill="var(--color-icon-lineart)" />
    <path
      d="M8.75,4.5v7a.75.75,0,0,1-1.5,0v-7a.75.75,0,0,1,1.5,0Z"
      fill="#fff"
    />
    <path
      d="M8.53,4,12,7.47a.75.75,0,0,1-1,1.06l-3-3-3,3A.75.75,0,0,1,4,7.47L7.47,4A.69.69,0,0,1,8.53,4Z"
      fill="#fff"
    />
  </svg>
);

export const InlineIconSuccess = () => (
  <svg viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="8" fill="var(--color-icon-lineart)" />
    <path
      d="M11.5556 5.33301L6.66668 10.2219L4.44446 7.99967"
      stroke="var(--color-theme-bg, #fff)"
      strokeWidth="1.77333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InlineIconFailure = () => (
  <svg viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="8" fill="var(--color-icon-lineart)" />
    <path
      d="M10.6666 5.33301L5.33325 10.6663M5.33325 5.33301L10.6666 10.6663"
      stroke="#fff"
      strokeWidth="1.77333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function TimelineStatusIcon({
  className,
  status,
  progressFraction,
}) {
  switch (status) {
    case 'pending':
      return (
        <span className={classNames(styles.svgIcon, styles.xlight, className)}>
          <InlineIconPending />
        </span>
      );
    case 'progress':
      return (
        <span
          className={classNames(styles.svgIcon, styles.signedEvent, className)}
        >
          <InlineIconInProgress progressFraction={progressFraction} />
        </span>
      );
    case 'next':
      return (
        <span className={classNames(styles.svgIcon, styles.light, className)}>
          <InlineIconUpArrow />
        </span>
      );
    case 'previous':
      return (
        <span className={classNames(styles.svgIcon, styles.light, className)}>
          <InlineIconDownArrow />
        </span>
      );
    case 'completed':
      return (
        <span className={classNames(styles.svgIcon, styles.light, className)}>
          <InlineIconSuccess />
        </span>
      );
    case 'signed':
      return (
        <span
          className={classNames(styles.svgIcon, styles.signedEvent, className)}
        >
          <InlineIconSuccess />
        </span>
      );
    case 'succeeded':
      return (
        <span
          className={classNames(styles.svgIcon, styles.successEvent, className)}
        >
          <InlineIconSuccess />
        </span>
      );
    case 'failed':
      return (
        <span
          className={classNames(styles.svgIcon, styles.failureEvent, className)}
        >
          <InlineIconFailure />
        </span>
      );
    case 'expired':
      return (
        <span className={classNames(styles.svgIcon, styles.light, className)}>
          <InlineIconFailure />
        </span>
      );
  }
  return null;
}
